import { jsx as r } from "react/jsx-runtime";

import { memo as t } from "react";

import o from "../hooks/useGlobals.js";

import { startOfWeek as e, times as a, addDays as s } from "../utils/index.js";

const m = e(0), c = a(7, (r => s(m, r))), i = t((() => {
    const {formatters: t} = o();
    return r("tr", {
        children: c.map((o => {
            const e = t.WeekDayAbbr.format(o);
            return r("th", {
                scope: "col",
                className: "py-s",
                abbr: e,
                "aria-label": e,
                children: t.WeekDay.format(o)
            }, o);
        }))
    });
}));

export { i as default };
//# sourceMappingURL=DaysTableHeaderRows.js.map
